import HttpErrorResponseModel from "models/HttpErrorResponseModel";
import { ReduxDispatch } from "models/ReduxProps";
import ResponseAuthTokensModel from "stores/shared/models/ResponseAuthTokensModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import ActionUtility from "utilities/ActionUtility";
import AccessoRequestModel from "./models/AccessoRequestModel";
import CambioPasswordRequestModel from "./models/CambioPasswordRequestModel";
import ExternalAuthenticateRequestModel from "./models/ExternalAuthenticateRequestModel";
import ExternalInfoModel from "./models/ExternalInfoModel";
import ProfiloUtenteModel from "./models/ProfiloUtenteModel";
import RecuperoPasswordRequestModel from "./models/RecuperoPasswordRequestModel";
import UtenteModel from "./models/UtenteModel";
import UtenteEffect from "./UtenteEffect";
import UserInfoModel from "./models/UserInfoModel";
import UserPermissionModel from "./models/UserPermissionModel";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | ProfiloUtenteModel
    | ResponseAuthTokensModel
    | ResponseEsitoModel
    | UtenteModel
    | UserInfoModel
    | UserPermissionModel;

export default class UtenteAction {
    public static readonly REQUEST_COOKIE_CONSENT_SET: string = "UtenteAction.REQUEST_COOKIE_CONSENT_SET";
    public static readonly REQUEST_COOKIE_CONSENT_SET_FINISHED: string =
        "UtenteAction.REQUEST_SET_COOKIE_CONSENT_FINISHED";

    public static readonly REQUEST_MENU_SIZE_SET: string = "UtenteAction.REQUEST_MENU_SIZE_SET";
    public static readonly REQUEST_MENU_SIZE_SET_FINISHED: string = "UtenteAction.REQUEST_MENU_SIZE_SET_FINISHED";

    public static readonly REQUEST_UTENTE_LOGIN_GET: string = "UtenteAction.REQUEST_UTENTE_LOGIN_GET";
    public static readonly REQUEST_UTENTE_LOGIN_GET_FINISHED: string = "UtenteAction.REQUEST_UTENTE_LOGIN_GET_FINISHED";

    public static readonly REQUEST_UTENTE_LOGOUT_GET: string = "UtenteAction.REQUEST_UTENTE_LOGOUT_GET";
    public static readonly REQUEST_UTENTE_LOGOUT_GET_FINISHED: string =
        "UtenteAction.REQUEST_UTENTE_LOGOUT_GET_FINISHED";

    public static readonly REQUEST_UTENTE_LOGIN_REQUIRED_SET: string = "UtenteAction.REQUEST_UTENTE_LOGIN_REQUIRED_SET";
    public static readonly REQUEST_UTENTE_LOGIN_REQUIRED_SET_FINISHED: string =
        "UtenteAction.REQUEST_UTENTE_LOGIN_REQUIRED_SET_FINISHED";

    public static readonly REQUEST_UTENTE_GET: string = "UtenteAction.REQUEST_UTENTE_GET";
    public static readonly REQUEST_UTENTE_GET_FINISHED: string = "UtenteAction.REQUEST_UTENTE_GET_FINISHED";

    public static readonly REQUEST_USERINFO_GET: string = "UtenteAction.REQUEST_USERINFO_GET";
    public static readonly REQUEST_USERINFO_GET_FINISHED: string = "UtenteAction.REQUEST_USERINFO_GET_FINISHED";

    public static readonly REQUEST_UTENTE_RECUPERO_PASSWORD_SET: string =
        "UtenteAction.REQUEST_UTENTE_RECUPERO_PASSWORD_SET";
    public static readonly REQUEST_UTENTE_RECUPERO_PASSWORD_SET_FINISHED: string =
        "UtenteAction.REQUEST_UTENTE_RECUPERO_PASSWORD_SET_FINISHED";

    public static readonly REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD_GET: string =
        "UtenteAction.REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD_GET";
    public static readonly REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD_GET_FINISHED: string =
        "UtenteAction.REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD_GET_FINISHED";

    public static readonly REQUEST_UTENTE_CAMBIO_PASSWORD_SET: string =
        "UtenteAction.REQUEST_UTENTE_CAMBIO_PASSWORD_SET";
    public static readonly REQUEST_UTENTE_CAMBIO_PASSWORD_SET_FINISHED: string =
        "UtenteAction.REQUEST_UTENTE_CAMBIO_PASSWORD_SET_FINISHED";

    public static readonly REQUEST_AUTHENTICATE_EXTERNAL: string = "UtenteAction.REQUEST_AUTHENTICATE_EXTERNAL";
    public static readonly REQUEST_AUTHENTICATE_EXTERNAL_FINISHED: string =
        "UtenteAction.REQUEST_AUTHENTICATE_EXTERNAL_FINISHED";

    public static readonly REQUEST_AUTHENTICATE_LOGOUT: string = "UtenteAction.REQUEST_AUTHENTICATE_LOGOUT";
    public static readonly REQUEST_AUTHENTICATE_LOGOUT_FINISHED: string =
        "UtenteAction.REQUEST_AUTHENTICATE_LOGOUT_FINISHED";

    public static readonly AUTHENTICATE_SET_EXTERNAL_INFO: string = "UtenteAction.AUTHENTICATE_SET_EXTERNAL_INFO";
    public static readonly AUTHENTICATE_RESET: string = "UtenteAction.AUTHENTICATE_RESET";
    public static readonly SET_USER_AUTHENTICATED: string = "UtenteAction.SET_USER_AUTHENTICATED";

    public static readonly REQUEST_USER_PERMISSIONS_GET: string = "UtenteAction.REQUEST_USER_PERMISSIONS_GET";
    public static readonly REQUEST_USER_PERMISSIONS_GET_FINISHED: string =
        "UtenteAction.REQUEST_USER_PERMISSIONS_GET_FINISHED";

    public static cookieConsentSet(consent: boolean): any {
        return ActionUtility.createAction(UtenteAction.REQUEST_COOKIE_CONSENT_SET_FINISHED, consent);
    }

    public static menuSizeSet(full: boolean): any {
        return ActionUtility.createAction(UtenteAction.REQUEST_MENU_SIZE_SET_FINISHED, full);
    }

    public static utenteLoginGet(request: AccessoRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseAuthTokensModel>(
                dispatch,
                UtenteAction.REQUEST_UTENTE_LOGIN_GET,
                UtenteEffect.utenteLoginGet,
                request
            );
        };
    }

    public static utenteLoginExternalSet(tokens: ResponseAuthTokensModel): any {
        return ActionUtility.createAction(UtenteAction.REQUEST_UTENTE_LOGIN_GET_FINISHED, tokens);
    }

    public static utenteLogoutGet(): any {
        return ActionUtility.createAction(UtenteAction.REQUEST_UTENTE_LOGOUT_GET_FINISHED);
    }

    public static utenteLoginRequiredSet(required: boolean): any {
        return ActionUtility.createAction(UtenteAction.REQUEST_UTENTE_LOGIN_REQUIRED_SET_FINISHED, required);
    }

    public static utenteGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<UtenteModel>(
                dispatch,
                UtenteAction.REQUEST_UTENTE_GET,
                UtenteEffect.utenteGet
            );
        };
    }

    public static userInfoGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<UserInfoModel>(
                dispatch,
                UtenteAction.REQUEST_USERINFO_GET,
                UtenteEffect.userInfoGet
            );
        };
    }

    public static utenteRecuperoPasswordSet(request: RecuperoPasswordRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UtenteAction.REQUEST_UTENTE_RECUPERO_PASSWORD_SET,
                UtenteEffect.utenteRecuperoPasswordSet,
                request
            );
        };
    }

    public static verificaTokenRecuperoPasswordGet(token: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UtenteAction.REQUEST_VERIFICA_TOKEN_RECUPERO_PASSWORD_GET,
                UtenteEffect.verificaTokenRecuperoPasswordGet,
                token
            );
        };
    }

    public static utenteCambioPasswordSet(request: CambioPasswordRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseEsitoModel>(
                dispatch,
                UtenteAction.REQUEST_UTENTE_CAMBIO_PASSWORD_SET,
                UtenteEffect.utenteCambioPasswordSet,
                request
            );
        };
    }

    public static externalAuthenticate(request: ExternalAuthenticateRequestModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseAuthTokensModel>(
                dispatch,
                UtenteAction.REQUEST_AUTHENTICATE_EXTERNAL,
                UtenteEffect.externalAuthenticate,
                request
            );
        };
    }

    public static setExternalInfo(info: ExternalInfoModel): any {
        return ActionUtility.createAction(UtenteAction.AUTHENTICATE_SET_EXTERNAL_INFO, info);
    }

    public static resetAll(): any {
        return ActionUtility.createAction(UtenteAction.AUTHENTICATE_RESET);
    }

    public static setUserAuthenticated(): any {
        return ActionUtility.createAction(UtenteAction.SET_USER_AUTHENTICATED);
    }

    public static userPermissionsGet(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<UserPermissionModel>(
                dispatch,
                UtenteAction.REQUEST_USER_PERMISSIONS_GET,
                UtenteEffect.userPermissionsGet
            );
        };
    }

    public static logout(request: ResponseAuthTokensModel): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResponseAuthTokensModel>(
                dispatch,
                UtenteAction.REQUEST_AUTHENTICATE_LOGOUT,
                UtenteEffect.logout,
                request
            );
        };
    }
}
